import React from 'react'; 
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useLocation } from "react-router-dom";
import { loginDetails } from '../Home/Login';
import { Crop } from '../../../node_modules/@mui/icons-material/index';



const AddNewCrop = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [flag, setFlag] = useState(false);
    const [cropsDataCodeValue, setcropsDataCodeValue] = useState("");
    const [cropsIntervalDaysData, setcropsIntervalDaysData] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [statesData, setStatesData] = useState([]);
    const [districtValue, setDistrictValue] = useState("");
    const [districtData, setDistrictData] = useState([]);
    const [cropsValue, setCropsValue] = useState("");
    const [cropsData, setfetchCropsData] = useState([]);
    const [visibility, setVisibility] = useState("");
    const [isActive, setIsActive] = useState("");

    const [cropCode, setCropCode] = useState("");
    const [cropName, setCropName] = useState("");
    const [commonName, setCommonName] = useState("");
    const [scientificName, setScientificName] = useState("");
    const [cropcategoryData, setCropcategoryData] = useState([]);
    const [cropCategoryValue, setCropCategoryValue] = useState("");
    const [cropCodeRandom, setCropCodeRandom] = useState("")

    useEffect(() => {
        getCropCategory()
        if (flag == true) {
            //fetchData2();
        }
    }, [flag])

    useEffect(() => {
        // useEffect to set defaultValue in dropdown meun
        if (state) {
          console.log("stateData", state)
            getCropCategory()
            getCrops()

            setCropCategoryValue(state.cropsDataCode.cropCategoryCode)
            setCropName(state.cropsDataCode.cropName)
            setCropCode(state.cropsDataCode.cropicCode)
            setCropCodeRandom(state.cropsDataCode.cropCode)
            setCommonName(state.cropsDataCode.commonName)
            setScientificName(state.cropsDataCode.scientificName)
            setcropsDataCodeValue(state.cropsDataCode.cropIntervalCode)
           
           
        }
    }, [])

    function getStates() {
        const fetchStates = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/states`);
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }

    function getCrops() {
        const fetchCrops = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop`);
            setfetchCropsData(result.data.dataContent);
        };
        fetchCrops();
    }

    function handleCrops(value) {
        setCropsValue(value);
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "cropCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    }
    function handleState(value) {
        if(value === "NA") { return}
        setStateValue(value);
        setDistrictData([])
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "stateCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/district`, requestOptions)
            .then(response => response.text())
            .then(result => setDistrictData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));


    }
    function handleDistrict(value) {
        //setStateValue(value);
        //setDistrictValue([])
        setDistrictValue(value)

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "DistrictCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    }

    function ValidateCropInteval() {
        console.log("datascd", stateValue, cropsValue , cropsIntervalDaysData)
        let valid = false;
        
   if(cropName === "" || cropName === "Choose...") {
    valid = false;
    alert("Enter Crop Name")
    return;
   }else {
    valid = true
   }
   
   if(cropCode === "" ) {
    valid = false;
    alert("Enter Crop Code")
    return;
   }else {
    valid = true
   }

   if(cropCategoryValue === "" || cropCategoryValue === "Choose...") {
    valid = false;
    alert("Select Any Crop Category")
    return;
   }else {
    valid = true
   }

   if(valid === true) {
    // console.log("valid9", valid)
     state ? UpdateCropData() : AddNewCrops()
  }
   

    }

    function AddNewCrops() {
      
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "cropicCode": cropCode,
            "createdByUC": localStorage.getItem("userCodeGlobal"),
            "cropCategoryCode": cropCategoryValue,
            "cropName": cropName,
            "commonName": commonName,
            "scientificName": scientificName
        });
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }
        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop/addCrop`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/master/crop")
                }
            })
            .catch(error => console.log('error', error));
    }

    function UpdateCropData() {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            
            "cropCode": cropCodeRandom,
            "cropicCode": cropCode,
            "modifiedByUC": localStorage.getItem("userCodeGlobal"),
            "cropCategoryCode": cropCategoryValue,
            "cropName": cropName,
            "commonName": commonName,
            "scientificName": scientificName,
            "visibility": "Y",
            "isActive": "Y"
          
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/master/crop")
                }
            })
            .catch(error => console.log('error', error));
    }

    //async function fetchData2() {
    //    const result = await axios('/api/users');
    //    setUsersData(result.data.dataContent);
    //}

    function handleCropCategory() {

    }


    function getCropCategory() {
        const fetchStates = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropcategory`);
            setCropcategoryData(result.data.dataContent);
        };
        fetchStates();
    }

    function handleResetForm() {
        setCropName("");
        setCropCode("");
        setCommonName("");
        setScientificName("");
        setCropCategoryValue("");
      }

      function handleValidateCropName(value) {
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("cropName").value = valueFinal;
        setCropName(valueFinal)
    }

    function handleValidateCommonName(value) {
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("commonName").value = valueFinal;
        setCommonName(valueFinal)
    }
    function handleValidateScientificName(value) {
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("scientificName").value = valueFinal;
        setScientificName(valueFinal)
    }

    function handleValidateCropCode(value) {
        const valueFinal = value.replace(/\D/g, "");
        setCropCode(valueFinal)
      }

     return (
        <>
           
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Add New Crops</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Crops</li>
                            <li className="breadcrumb-item active">Add New Crops</li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="card dashboard">
                        <div className="card-body">

                            <form className="g-3 addNewUser">
                                <div className="row">
                                    <h5 className="formgrouping"> Add Crops</h5>

                                    <div className="col-md-4">
                                        <label htmlFor="cropcategory" className="form-label">Select Crop Category</label>
                                        <select id="cropcategory" required className="form-select"  onChange={(e) => setCropCategoryValue(e.target.value)} value={cropCategoryValue} >
                                            <option  defaultValue="NA">Choose...</option>
                                            {cropcategoryData.map((item, id) => {
                                                return <option key={id} value={item.cropCategoryCode}> {item.cropCategoryName}</option>
                                            })}
                                        </select>
                                    </div>

                                    
                                        <div className="col-md-4">
                                            <label htmlFor="cropName" className="form-label"> Crop Name</label>
                                            <input id="cropName" required className="form-control" placeholder="Enter Crop Name" onChange={e => handleValidateCropName(e.target.value)} value={cropName }  maxLength={50} />
                                        </div>
                                    

                                 
                                        <div className="col-md-4">
                                            <label htmlFor="commonName" className="form-label"> Common Name</label>
                                            <input id="commonName" required className="form-control" placeholder="Enter Common Name" onChange={e => handleValidateCommonName(e.target.value)} value={commonName }    maxLength={50}/>
                                        </div>
                                   

                                  
                                        <div className="col-md-4">
                                            <label htmlFor="scientificName" className="form-label"> Scientific Name</label>
                                            <input id="scientificName" required className="form-control" placeholder="Enter Scientific Name" onChange={e => handleValidateScientificName(e.target.value)} value={scientificName}   maxLength={50}  />
                                        </div>
                                  

                                  
                                        <div className="col-md-4">
                                            <label htmlFor="cropicCode" className="form-label"> Crop Code (In cropic)</label>
                                            <input id="cropicCode" required className="form-control" placeholder="Enter Crop Code" onChange={e => handleValidateCropCode(e.target.value)} value={cropCode}  type="test" maxLength="10"  />
                                        </div>
                                  
                                 

                   
                                  

                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center">
                                        {state ? <button className="btn btn-success me-md-2" type="button" onClick={ValidateCropInteval}>Update</button> : <button className="btn btn-success me-md-2" type="button" onClick={ValidateCropInteval}>Save</button>}

                                        <button className="btn btn-outline-primary" type="reset" onClick={handleResetForm}>Reset</button>
                                        <button className="btn btn-outline-danger" type="button" onClick={() => navigate("/master/crop") }>Cancel</button>
                                        
                                    </div>


                                </div>
                            </form>
                        </div>
                    </div>




                </section>
            </main>
           
        </>
    )
}

export default AddNewCrop;